import { inject, Injectable } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';

import { AppConfigLoader } from '../../config/app-config.loader';

import { BrowserService } from './browser.service';

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  private readonly translocoService: TranslocoService = inject(TranslocoService);
  private readonly browserService = inject(BrowserService);
  private readonly appConfigLoader = inject(AppConfigLoader);

  /**
   * Opens the Shop
   */
  async openShop(): Promise<void> {
    const { shopUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(shopUrl[lang as keyof typeof shopUrl] ?? shopUrl.fallback);
  }

  /**
   * Opens the Subscription Manager
   */
  async openSubscriptionManager(): Promise<void> {
    const { subscriptionManagerUrl } = this.appConfigLoader.activeConfig();
    const lang = this.translocoService.getActiveLang();
    return await this.browserService.openExternalUrl(subscriptionManagerUrl[lang as keyof typeof subscriptionManagerUrl] ?? subscriptionManagerUrl.fallback);
  }
}
